import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import bonusContent from './bonusContent';
import configuration from './configuration';
import initialization from './initialization';
import params from './params';
import filter from './filter';
import search from './search';
import playerLock from './playerLock';
import experiment from './experiment';
import growthbookExperiments from './growthbookExperiments';
import storageReducer from './storage';

const gamesPersistConfig = {
  key: 'live-casino:storage',
  storage,
};

export default combineReducers({
  bonusContent,
  configuration,
  filter,
  initialization,
  params,
  search,
  playerLock,
  experiment,
  growthbookExperiments,
  storage: persistReducer(gamesPersistConfig, storageReducer),
});
